import { NO_ELEMENT, hasElements } from 'utils';
import { Faq as FaqModel } from 'models/Faq';
import styles from './faqContainer.scss';
import { CategoryFaqs } from 'views/ProductPage/faqs/themes/PP';
import { Section } from 'components/Section';

interface OwnProps {
  faqs?: FaqModel[];
  totalNumberOfFaqs: number;
  title: string;
}

export const FaqContainer = ({ faqs, totalNumberOfFaqs, title }: OwnProps) => {
  if (!faqs || !hasElements(faqs)) {
    return NO_ELEMENT;
  }

  return (
    <Section contentClassName={styles.faqBlock}>
      <CategoryFaqs
        faqs={faqs}
        totalNumberOfFaqs={totalNumberOfFaqs}
        title={title}
        phoneSize="1"
        tabletSize="2"
      />
    </Section>
  );
};
